import { Card, CardBody, Col, Row } from "reactstrap";
import { IconsTitle } from "../../../Constants/Constants";
import { IconsBodyProps } from "../../../Types/IconsType";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const ThemifyIconBody: React.FC<IconsBodyProps> = ({ title, iconType, parentCallback }) => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={`${title} ${IconsTitle}`} />
        <CardBody>
          <Row className="icon-lists">
            {iconType.map((icon, i) => (
              <Col sm="6" md="4" lg="3" key={i} onClick={() => parentCallback(icon)}>
                <i className={icon}></i>
                {icon}
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ThemifyIconBody;
